import { castArray } from "./castArray.js";
const appendFilters = function () {
  let objWithFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let filters = arguments.length > 1 ? arguments[1] : undefined;
  return {
    ...objWithFilters,
    filters: [...(objWithFilters.filters || []), ...castArray(filters)]
  };
};
export { appendFilters };